export const DIALOG_ID = "compare-plans-dialog";
